var map = {
	"./de/general14/slide1.svg": 11812,
	"./en/general14/slide1.svg": 108640,
	"./es/general14/slide1.svg": 7563,
	"./fr/general14/slide1.svg": 703187,
	"./nl/general14/slide1.svg": 109081,
	"./pt/general14/slide1.svg": 917103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 249584;